import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import dayjs from "dayjs";
import "dayjs/locale/th";
import AdvancedFormat from "dayjs/plugin/advancedFormat";
import buddhistEra from "dayjs/plugin/buddhistEra";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isLeapYear from "dayjs/plugin/isLeapYear";
import { createPinia } from "pinia";
import { createApp } from "vue";
import { createMetaManager } from "vue-meta";
import App from "./App.vue";
import "./assets/styles/main.css";
import router from "./router";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

dayjs.extend(buddhistEra);
dayjs.extend(AdvancedFormat);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(isLeapYear);
dayjs.locale("th");

const app = createApp(App);

app.component("VueDatePicker", VueDatePicker);
app.component('QuillEditor', QuillEditor)

app.use(createPinia());
app.use(router);
app.use(Antd);
app.use(createMetaManager());

router
  .isReady()
  .then(() => {
    app.mount("#app");
  })
  .catch((error) => {
    console.error("Failed to initialize router:", error);
    app.mount("#app");
  });
